<div class="d-flex align-items-center justify-content-between">
  <div class=""></div>
  <mat-form-field appearance="outline">
    <mat-label>Buscar por modelo o número de serie</mat-label>
    <input matInput [(ngModel)]="textoBusqueda" (input)="onBuscar($event)" #input>
  </mat-form-field>
</div>
<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort id="tabla">
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td class="padding-table" mat-cell *matCellDef="let element">{{ element.tipo }}</td>
      </ng-container>

      <ng-container matColumnDef="marca">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Marca</th>
        <td class="padding-table" mat-cell *matCellDef="let element">
          {{ element.marca | uppercase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="modelo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Modelo</th>
        <td class="padding-table" mat-cell *matCellDef="let element">
          {{ element.modelo | uppercase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="chip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Chip</th>
        <td class="padding-table" mat-cell *matCellDef="let element">
          {{ element.chip || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="numeroSerie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>N° Serie</th>
        <td class="padding-table" mat-cell *matCellDef="let element">
          {{ element.numeroSerie }}
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
        <td class="padding-table" mat-cell *matCellDef="let element">
          {{ element.estado }}
        </td>
      </ng-container>

      <ng-container matColumnDef="accesorios">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Accesorios</th>
        <td class="padding-table" mat-cell *matCellDef="let element">
          {{ element.accesorios || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="observacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Observación</th>
        <td class="padding-table" mat-cell *matCellDef="let element">
          {{ element.observacion || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Acciones</th>
        <td class="padding-table d-flex" mat-cell *matCellDef="let element">
          <p-button class="m-1" (click)="editarEquipo(element)" icon="pi pi-pencil" styleClass="p-button-rounded p-button-warning p-button-outlined"></p-button>
          <p-button class="m-1" [disabled]="element.estado === 'DE_BAJA'" (click)="darDeBaja(element.id)" icon="pi pi-power-off" styleClass="p-button-rounded p-button-danger p-button-outlined"></p-button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      aria-label="Seleccionar pagina de equipos."
    >
    </mat-paginator>
  </div>
